import { formatScaled, parseScaled } from "./decimal";

export function toQ4(input: string): number {
  return parseScaled(input, 4, "invalid_qty");
}

export function formatQty(q4: number, decimals = 0): string {
  return formatScaled(q4, 4, decimals);
}
